import Css from "./Css.js";
import LevelMax from "../../Images/level_max.png";
import LevelMin from "../../Images/level_min.png";
import { useState } from "react";
import throttle from 'lodash.throttle';
import orderUtil from '../../Utils/orderUtil.js';

function SlideLimit(props){

  const {controlBoxId,level,points} = props.data;
  const {setLevelRange,pauseVideo,setLevel,setPoints} = props.method;
  const controlBoxEl = document.getElementById(controlBoxId);
  const maxDivDefaultTop = 66;
  const [maxDiv, setMaxDiv] = useState({ top:maxDivDefaultTop });
  const minDivDefalutBottom = 27;
  const [minDiv, setMinDiv] = useState({ bottom:minDivDefalutBottom });
  const lvHeight = orderUtil.oneLevelHeight;

  const updateLastPointLevel = (level) => {
    let newPoint = orderUtil.deepClone(points);
    let p = { t:newPoint[newPoint.length-1].t + 100, v:level };
    newPoint.push(p);
    setPoints(newPoint);
  }

  //滑动限制最大level
  const maxLimitBtnMouseDown = (e)=> {
    pauseVideo();
    let prevY = e.clientY;
    controlBoxEl.onmousemove = throttle(function(ev) {
      let moveDistanceY = parseInt(ev.clientY - prevY);
      let tmp = maxDiv.top + moveDistanceY;
      tmp = Math.ceil((tmp - maxDivDefaultTop)/lvHeight)*lvHeight + maxDivDefaultTop;
      if(tmp < maxDivDefaultTop){
        tmp = maxDivDefaultTop;
      }
      if(tmp > (16*lvHeight + maxDivDefaultTop)){ //最多滑动16个level
        tmp =  16*lvHeight + maxDivDefaultTop;
      }
      if(tmp + minDiv.bottom < (20*lvHeight + maxDivDefaultTop)){ //至少保留6个level可以选择
        setMaxDiv({top:tmp});
        let max = 20 - parseInt((tmp - maxDivDefaultTop)/lvHeight);
        let min = parseInt((minDiv.bottom - minDivDefalutBottom)/lvHeight);
        let obj = {min,max};
        setLevelRange(obj);
        if(min > level){
          setLevel(min);
          updateLastPointLevel(min);
        }else if(max < level){
          setLevel(max);
          updateLastPointLevel(max);
        }
      }
      controlBoxEl.onmouseup = function(){
        controlBoxEl.onmousedown = null;
        controlBoxEl.onmousemove = null;
      };
      return false;
    }, 50);
  }
  //滑动限制最小level
  const minLimitBtnMouseDown = (e)=> {
    pauseVideo();
    let prevY = e.clientY;
    controlBoxEl.onmousemove = throttle(function(ev) {
      let moveDistanceY = parseInt(ev.clientY - prevY);
      let tmp = minDiv.bottom - moveDistanceY;
      tmp = Math.floor((tmp - minDivDefalutBottom)/lvHeight)*lvHeight;
      if(tmp < 0){
        tmp = 0;
      }
      if(tmp < orderUtil.controlBoxHeight - maxDiv.top - 5*lvHeight - minDivDefalutBottom){ //至少保留5个level可以选择
        setMinDiv({bottom:tmp+minDivDefalutBottom});
        let max = parseInt((20*lvHeight - maxDiv.top + maxDivDefaultTop)/lvHeight);
        let min = parseInt(tmp/lvHeight);
        let obj = {min, max};
        setLevelRange(obj);
        if(min > level){
          setLevel(min);
          updateLastPointLevel(min);
        }else if(max < level){
          setLevel(max);
          updateLastPointLevel(max);
        }
      }
      controlBoxEl.onmouseup = function(){
        controlBoxEl.onmousedown = null;
        controlBoxEl.onmousemove = null;
      };
      return false;
    }, 50);
  }

  return (
    <>
      <div style={ Css.MaxCoverDiv(maxDiv.top + 6) }></div>
      <img onMouseDown={ (e)=>{ maxLimitBtnMouseDown(e) } } src={LevelMax} style={ Css.LevelMaxBtn(maxDiv.top) } alt="" />
      <div style={ Css.SlideLimit }>{ createMark() }</div>
      <div style={ Css.MinCoverDiv(minDiv.bottom) }></div>
      <img onMouseDown={ (e)=>{ minLimitBtnMouseDown(e) } } src={LevelMin} style={ Css.LevelMinBtn(minDiv.bottom) } alt="" />
    </>
  )

  function createMark(){
    let divArr = [];
    for(let i=0; i<20; i++){
      divArr.push(
        <div key={"level_mark_div" + i} style={Css.Mark(i)}></div>
      );
    }
    return divArr;
  }
}

export default SlideLimit;